



export const selectUser = (state) => state.auth.user;
export const selectToken = (state) => state.auth.token;
export const selectFirsthFactorAuth = (state) => state.auth.firsthFactorAuth;
export const selectChecking = (state) => state.auth.checking;
export const selectLoading = (state) => state.auth.loading;
export const selectError = (state) => state.auth.error;
